import React, { useState } from 'react';
import './RadioGroup.css';
import RadioButton from '../radioButton/RadioButton';
import Label from '../../components/label/Label';

const RadioGroup = (props) => {
	let [selected, setSelected] = useState(props.value);
	const renderOptions = () => {
		let display = [];
		for (let i in props.options) {
			let option = props.options[i];
			display.push(
				<div className="option">
					<RadioButton
						value={i === selected}
						onChange={(value) => {
							valueChanged(i, value);
						}}
					/>
					<Label medium-small black-light>
						{option}
					</Label>
				</div>
			);
		}
		return display;
	};

	const valueChanged = (value, selected) => {
		if (!selected) {
			setSelected(null);
		} else {
			setSelected(value);
			if (props.onChange) props.onChange(value);
		}
	};

	return <div className="g-radio-group">{renderOptions()}</div>;
};

export default RadioGroup;



// WEBPACK FOOTER //
// ./src/inputs/radioGroup/RadioGroup.jsx